import { TestIdDomain } from 'constants/testIds';

const ChecklistsTestIdsScope = {
  CHECKLIST_FORM: 'checklist-form',
  CHECKLIST_ITEMS_CONTROLS: 'checklist-items-controls',
  CHECKLIST_ITEMS_TABLE_ROW: 'checklist-items-table-row',
  CHECKLIST_ITEM_FORM: 'checklist-item-form',
};

export const ChecklistsTestIds = {
  // Checklist
  CHECKLIST_DOWNLOAD_BUTTON: `${TestIdDomain.CHECKLISTS}.download-button`,
  CHECKLIST_RESULT_LABEL: `${TestIdDomain.CHECKLISTS}.result-label`,

  // ChecklistCategoryForm
  CHECKLIST_CATEGORY_FORM_SUBMIT_BUTTON: 'checklist-category-form.submit-button',

  // ChecklistForm
  CHECKLIST_FORM_NAME_INPUT: `${ChecklistsTestIdsScope.CHECKLIST_FORM}.name-input`,
  CHECKLIST_FORM_SUBMIT_BUTTON: `${ChecklistsTestIdsScope.CHECKLIST_FORM}.submit-button`,

  // ChecklistItemForm
  CHECKLIST_ITEM_FORM_NAME_INPUT: `${ChecklistsTestIdsScope.CHECKLIST_ITEM_FORM}.name-input`,
  CHECKLIST_ITEM_FORM_SUBMIT_BUTTON: `${ChecklistsTestIdsScope.CHECKLIST_ITEM_FORM}.submit-button`,

  // ChecklistItemsTableControls
  CHECKLIST_ITEMS_CONTROLS_CANCEL_BUTTON: `${ChecklistsTestIdsScope.CHECKLIST_ITEMS_CONTROLS}.cancel-button`,
  CHECKLIST_ITEMS_CONTROLS_SUBMIT_BUTTON: `${ChecklistsTestIdsScope.CHECKLIST_ITEMS_CONTROLS}.submit-button`,

  // ChecklistItemsTableRow
  CHECKLIST_ITEMS_TABLE_ROW_DETERMINATION_RADIO: `${ChecklistsTestIdsScope.CHECKLIST_ITEMS_TABLE_ROW}.determination-radio`,
  CHECKLIST_ITEMS_TABLE_ROW_EXPRESSION_RESULT_CELL: `${ChecklistsTestIdsScope.CHECKLIST_ITEMS_TABLE_ROW}.expression-result-cell`,
  CHECKLIST_ITEMS_TABLE_ROW_NAME_CELL: `${ChecklistsTestIdsScope.CHECKLIST_ITEMS_TABLE_ROW}.name-cell`,
  CHECKLIST_ITEMS_TABLE_ROW_OVERRIDEN_BY_CELL: `${ChecklistsTestIdsScope.CHECKLIST_ITEMS_TABLE_ROW}.overriden-by-cell`,
  CHECKLIST_ITEMS_TABLE_ROW_RESULT_CELL: `${ChecklistsTestIdsScope.CHECKLIST_ITEMS_TABLE_ROW}.result-cell`,
  CHECKLIST_ITEMS_TABLE_ROW_RESULT_ICON: `${ChecklistsTestIdsScope.CHECKLIST_ITEMS_TABLE_ROW}.result-icon`,
  CHECKLIST_ITEMS_TABLE_ROW_RESULT_LABEL: `${ChecklistsTestIdsScope.CHECKLIST_ITEMS_TABLE_ROW}.result-label`,
  CHECKLIST_ITEMS_TABLE_ROW_RESULT_REASON: `${ChecklistsTestIdsScope.CHECKLIST_ITEMS_TABLE_ROW}.result-reason-label`,
  CHECKLIST_ITEMS_TABLE_ROW_WAS_OVERRIDEN_CELL: `${ChecklistsTestIdsScope.CHECKLIST_ITEMS_TABLE_ROW}.was-overriden-cell`,

  // Dynamic
  getChecklistId: checklistId => `${TestIdDomain.CHECKLISTS}.checklist-${checklistId}`,
  getChecklistCategoryId: categoryId => `${TestIdDomain.CHECKLISTS}.category-${categoryId}`,
};
